import React from "react";
import { Flash } from "~/entities/flash/types";
import "./styles.css";

const errorIcon = `url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmY0ZTQ0O30uYntmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjNweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPldhcm5pbmcgSWNvbjwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xMS4zMiwxLjJjLS43Mi0xLjQ4LTEuOTEtMS40OC0yLjYzLDBMLjgyLDE3LjNBMS43MywxLjczLDAsMCwwLDIuNSwyMGgxNWExLjczLDEuNzMsMCwwLDAsMS42OC0yLjdaIi8+PGxpbmUgY2xhc3M9ImIiIHgxPSIxMCIgeTE9IjYiIHgyPSIxMCIgeTI9IjExIi8+PGxpbmUgY2xhc3M9ImIiIHgxPSIxMCIgeTE9IjE3IiB4Mj0iMTAiIHkyPSIxNy4xIi8+PC9zdmc+)`;

const successIcon = `url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojMjA5NjA0O30uYntmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjNweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkV4Y2xhbWF0aW9uIE1hcmsgY29weTwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xMCwxOWE5LDksMCwxLDEsOS05QTksOSwwLDAsMSwxMCwxOVoiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTEwLDJhOCw4LDAsMSwxLTgsOCw4LDgsMCwwLDEsOC04bTAtMkExMCwxMCwwLDEsMCwyMCwxMCwxMCwxMCwwLDAsMCwxMCwwWiIvPjxsaW5lIGNsYXNzPSJiIiB4MT0iMTAiIHkxPSI0LjUiIHgyPSIxMCIgeTI9IjkuNSIvPjxsaW5lIGNsYXNzPSJiIiB4MT0iMTAiIHkxPSIxNS41IiB4Mj0iMTAiIHkyPSIxNS42Ii8+PC9zdmc+)`;

const warningIcon = `url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC45OCIgaGVpZ2h0PSIxOS45MyIgdmlld0JveD0iMCAwIDE4Ljk4IDE5LjkzIj4KICA8cGF0aCBkPSJtMTAuODEsMS4xMWMtLjcyLTEuNDgtMS45MS0xLjQ4LTIuNjMsMEwuMzEsMTcuMjFjLS41NS43OC0uMzUsMS44Ni40MywyLjQxLjM2LjI1LjgxLjM2LDEuMjUuMjloMTVjLjk0LjE0LDEuODMtLjUsMS45Ny0xLjQ1LjA3LS40NC0uMDQtLjg5LS4yOS0xLjI1TDEwLjgxLDEuMTFaIiBzdHlsZT0iZmlsbDogI2VmZDIxNTsiLz4KICA8bGluZSB4MT0iOS40OSIgeTE9IjUuOTEiIHgyPSI5LjQ5IiB5Mj0iMTAuOTEiIHN0eWxlPSJmaWxsOiBub25lOyBzdHJva2U6ICNmZmY7IHN0cm9rZS1saW5lY2FwOiByb3VuZDsgc3Ryb2tlLW1pdGVybGltaXQ6IDEwOyBzdHJva2Utd2lkdGg6IDNweDsiLz4KICA8bGluZSB4MT0iOS40OSIgeTE9IjE2LjkxIiB4Mj0iOS40OSIgeTI9IjE3LjAxIiBzdHlsZT0iZmlsbDogbm9uZTsgc3Ryb2tlOiAjZmZmOyBzdHJva2UtbGluZWNhcDogcm91bmQ7IHN0cm9rZS1taXRlcmxpbWl0OiAxMDsgc3Ryb2tlLXdpZHRoOiAzcHg7Ii8+Cjwvc3ZnPg==")`;

interface Props extends Flash {}

const FlashMessage: React.FC<Props> = ({ kind, message }) => {
  return (
    <div
      role="alert"
      data-type={kind}
      style={{
        backgroundColor: {
          failure: "#ffe6e6",
          error: "#ffe6e6",
          success: "#e6ffe6",
          warning: "#fffbde",
        }[kind],
      }}
      className="mx-auto mt-4 w-full max-w-[800px] self-center rounded-lg px-5 py-3 shadow-sm"
    >
      <p
        style={{
          backgroundImage: {
            failure: errorIcon,
            error: errorIcon,
            success: successIcon,
            warning: warningIcon,
          }[kind],
          color: {
            failure: "#cc0000",
            error: "#cc0000",
            success: "#0d800d",
            warning: "#57543f",
          }[kind],
        }}
        className="bg-left-center bg-no-repeat pl-8 text-sm"
      >
        {message}
      </p>
    </div>
  );
};

export default FlashMessage;
